const HDD_DATA = {
  Alberta: {
    Athabasca: 6000,
    Banff: 5500,
    Barrhead: 5740,
    Beaverlodge: 5700,
    Brooks: 4880,
    Calgary: 5000,
    Campsie: 5750,
    Camrose: 5500,
    Canmore: 5400,
    Cardston: 4700,
    Claresholm: 4680,
    'Cold Lake': 5860,
    Coleman: 5210,
    Coronation: 5640,
    Cowley: 4810,
    Drumheller: 5050,
    Edmonton: 5120,
    Edson: 5750,
    'Embarras Portage': 7100,
    Fairview: 5840,
    'Fort MacLeod': 4600,
    'Fort McMurray': 6250,
    'Fort Saskatchewan': 5420,
    'Fort Vermilion': 6700,
    'Grande Prairie': 5790,
    Habay: 6750,
    Hardisty: 5640,
    'High River': 4900,
    Hinton: 5500,
    Jasper: 5300,
    'Keg River': 6520,
    'Lac La Biche': 6100,
    Lacombe: 5500,
    Lethbridge: 4500,
    Manning: 6300,
    'Medicine Hat': 4540,
    'Peace River': 6050,
    'Pincher Creek': 4740,
    Ranfurly: 5700,
    'Red Deer': 5550,
    'Rocky Mountain House': 5640,
    'Slave Lake': 5850,
    Stettler: 5300,
    'Stony Plain': 5300,
    Suffield: 4770,
    Taber: 4580,
    'Turner Valley': 5220,
    Valleyview: 5600,
    Vegreville: 5780,
    Vermilion: 5740,
    Wagner: 5850,
    Wainwright: 5700,
    Wetaskiwin: 5500,
    Whitecourt: 5650,
    Wimborne: 5310,
  },
  'British Columbia': {
    '100 Mile House': 5030,
    Abbotsford: 2860,
    Agassiz: 2750,
    Alberni: 3100,
    Ashcroft: 3700,
    Bamfield: 2080,
    'Beatton River': 5230,
    'Bella Bella': 2150,
    'Bella Coola': 2660,
    'Burns Lake': 5450,
    'Cache Creek': 3700,
    'Campbell River': 3000,
    Carmi: 4750,
    Castlegar: 3580,
    Chetwynd: 5500,
    Chilliwack: 2780,
    Comox: 2930,
    Courtenay: 2930,
    Cranbrook: 4400,
    'Crescent Valley': 3650,
    Crofton: 2880,
    'Dawson Creek': 5900,
    'Dease Lake': 6730,
    'Dog Creek': 4800,
    Duncan: 2980,
    Elko: 4600,
    Fernie: 4750,
    'Fort Nelson': 6710,
    'Fort St. John': 5750,
    Glacier: 5800,
    Golden: 4750,
    'Gold River': 3230,
    'Grand Forks': 3820,
    Greenwood: 4100,
    Hope: 2820,
    'Jordan River': 2900,
    Kamloops: 3450,
    Kaslo: 3830,
    Kelowna: 3400,
    Kimberley: 4650,
    'Kitimat Plant': 3750,
    'Kitimat Townsite': 3900,
    Ladysmith: 2920,
    Langford: 2750,
    Lillooet: 3400,
    Lytton: 3300,
    Mackenzie: 5550,
    Masset: 3700,
    McBride: 4980,
    'McLeod Lake': 5450,
    Merritt: 3900,
    'Mission City': 2850,
    Montrose: 3600,
    Nakusp: 3560,
    Nanaimo: 2920,
    Nelson: 3500,
    'Ocean Falls': 3400,
    Osoyoos: 3100,
    Parksville: 2990,
    Penticton: 3350,
    'Port Alberni': 3100,
    'Port Alice': 3010,
    'Port Hardy': 3440,
    'Port McNeill': 3410,
    'Port Renfrew': 2900,
    'Powell River': 3100,
    'Prince George': 4720,
    'Prince Rupert': 3900,
    Princeton: 4250,
    'Qualicum Beach': 2990,
    'Queen Charlotte City': 3520,
    Quesnel: 4650,
    Revelstoke: 4000,
    'Salmon Arm': 3650,
    Sandspit: 3450,
    Sechelt: 2680,
    Sidney: 2850,
    Smithers: 5040,
    'Smith River': 7100,
    Sooke: 2900,
    Squamish: 2950,
    Stewart: 4350,
    Tahsis: 3150,
    Taylor: 5720,
    Terrace: 4150,
    Tofino: 3150,
    Trail: 3600,
    Ucluelet: 3120,
    'Burnaby (Simon Fraser Univ.)': 3100,
    Cloverdale: 2700,
    Haney: 2840,
    Ladner: 2600,
    Langley: 2700,
    'New Westminster': 2800,
    'North Vancouver': 2910,
    Richmond: 2800,
    'Surrey (88 Ave & 156 St.)': 2750,
    'Vancouver (City Hall)': 2825,
    'Vancouver (Granville St. & 41st Ave)': 2925,
    'West Vancouver': 2950,
    Vernon: 3600,
    Victoria: 2650,
    'Victoria (Gonzales Hts)': 2700,
    'Victoria (Mt Tolmie)': 2700,
    Whistler: 4180,
    'White Rock': 2620,
    'Williams Lake': 4400,
    Youbou: 3050,
  },
  Manitoba: {
    Beausejour: 5680,
    Boissevain: 5500,
    Brandon: 5760,
    Churchill: 8950,
    Dauphin: 5900,
    'Flin Flon': 6440,
    Gimli: 5800,
    'Island Lake': 6900,
    'Lac du Bonnet': 5730,
    'Lynn Lake': 7770,
    Morden: 5400,
    Neepawa: 5760,
    'Pine Falls': 5900,
    'Portage la Prairie': 5600,
    Rivers: 5840,
    Sandilands: 5650,
    Selkirk: 5700,
    'Split Lake': 7900,
    Steinbach: 5700,
    'Swan River': 6100,
    'The Pas': 6480,
    Thompson: 7600,
    Virden: 5620,
    Winnipeg: 5670,
  },
  Saskatchewan: {
    Assiniboia: 5180,
    Battrum: 5080,
    Biggar: 5720,
    Broadview: 5760,
    Dafoe: 5860,
    Dundurn: 5600,
    Estevan: 5340,
    'Hudson Bay': 6280,
    Humboldt: 6000,
    'Island Falls': 7100,
    Kamsack: 6040,
    Kindersley: 5550,
    Lloydminster: 5880,
    'Maple Creek': 4780,
    'Meadow Lake': 6280,
    Melfort: 6050,
    Melville: 5880,
    'Moose Jaw': 5270,
    Nipawin: 6300,
    'North Battleford': 5900,
    'Prince Albert': 6100,
    "Qu'Appelle": 5620,
    Regina: 5600,
    Rosetown: 5620,
    Saskatoon: 5700,
    Scott: 5960,
    Strasbourg: 5600,
    'Swift Current': 5150,
    'Uranium City': 7500,
    Weyburn: 5400,
    Yorkton: 6000,
  },
  'New Brunswick': {
    Alma: 4500,
    Bathurst: 5020,
    Boiesetown: 4900,
    Campbellton: 5500,
    Edmundston: 5320,
    Fredericton: 4670,
    Gagetown: 4460,
    'Grand Falls': 5300,
    Miramichi: 4950,
    Moncton: 4680,
    Oromocto: 4650,
    Sackville: 4590,
    'Saint Andrews': 4680,
    'Saint John': 4570,
    Shippagan: 4930,
    'St. George': 4680,
    'St. Stephen': 4700,
    Woodstock: 4910,
  },
  'Newfoundland and Labrador': {
    Argentia: 4600,
    Bonavista: 5000,
    Buchans: 5250,
    'Cape Harrison': 6900,
    'Cape Race': 4900,
    'Channel-Port aux Basques': 5000,
    'Corner Brook': 4760,
    Gander: 5110,
    'Grand Bank': 4550,
    'Grand Falls': 5020,
    'Happy Valley-Goose Bay': 6670,
    'Labrador City': 7710,
    'St. Anthony': 6440,
    Stephenville: 4850,
    "St. John's": 4800,
    'Twin Falls': 7790,
    Wabana: 4750,
    Wabush: 7710,
  },
  'Northwest Territories': {
    Aklavik: 9600,
    'Behchokǫ / Rae-Edzo': 8300,
    'Echo Bay / Port Radium': 9300,
    'Fort Good Hope': 8700,
    'Fort McPherson': 9150,
    'Fort Providence': 7620,
    'Fort Resolution': 7750,
    'Fort Simpson': 7660,
    'Fort Smith': 7300,
    'Hay River': 7550,
    Inuvik: 9600,
    'Mould Bay': 12900,
    'Norman Wells': 8510,
    Tungsten: 7700,
    'Ulukhaktok / Holman': 10700,
    Wrigley: 8050,
    Yellowknife: 8170,
  },
  'Nova Scotia': {
    Amherst: 4500,
    Antigonish: 4510,
    Bridgewater: 4140,
    Canso: 4400,
    Debert: 4500,
    Digby: 4020,
    'Greenwood (CFB)': 4140,
    Dartmouth: 4100,
    Halifax: 4000,
    Kentville: 4130,
    Liverpool: 3990,
    Lockeport: 4000,
    Louisbourg: 4530,
    Lunenburg: 4140,
    'New Glasgow': 4320,
    'North Sydney': 4500,
    Pictou: 4310,
    'Port Hawkesbury': 4500,
    Springhill: 4540,
    Stewiacke: 4400,
    Sydney: 4530,
    Tatamagouche: 4380,
    Truro: 4500,
    Wolfville: 4140,
    Yarmouth: 3990,
  },
  Nunavut: {
    Alert: 13030,
    'Arctic Bay': 11900,
    Arviat: 9850,
    'Baker Lake': 10700,
    Eureka: 13500,
    'Igluligaarjuk / Chesterfield Inlet': 10500,
    Iqaluit: 9980,
    'Iqaluktuuttiaq / Cambridge Bay': 11670,
    Isachsen: 13600,
    'Kangiqiniq / Rankin Inlet': 10500,
    'Kanngiqtugaapik / Clyde River': 11300,
    'Kugluktuk / Coppermine': 10300,
    'Nottingham Island': 10000,
    Resolute: 12360,
    'Resolution Island': 9000,
    'Salliq / Coral Harbour': 10720,
  },
  Ontario: {
    'Ailsa Craig': 3840,
    Ajax: 3820,
    Alexandria: 4600,
    Alliston: 4200,
    Almonte: 4620,
    Armstrong: 6500,
    Arnprior: 4680,
    Atikokan: 5750,
    Attawapiskat: 7100,
    Aurora: 4210,
    Bancroft: 4740,
    Barrie: 4380,
    Barriefield: 3990,
    Beaverton: 4300,
    Belleville: 3910,
    Belmont: 3840,
    'Borden (CFB)': 4300,
    Bracebridge: 4800,
    Bradford: 4280,
    Brampton: 4100,
    Brantford: 3900,
    Brighton: 4000,
    Brockville: 4060,
    "Burk's Falls": 5020,
    Burlington: 3740,
    Cambridge: 4100,
    Campbellford: 4280,
    Cannington: 4310,
    'Carleton Place': 4600,
    Cavan: 4400,
    Centralia: 3800,
    Chapleau: 5900,
    Chatham: 3470,
    Chesley: 4320,
    Clinton: 4150,
    Coboconk: 4500,
    Cobourg: 3980,
    Cochrane: 6200,
    Colborne: 3980,
    Collingwood: 4180,
    Cornwall: 4250,
    Corunna: 3600,
    'Deep River': 4900,
    Deseronto: 4070,
    Dorchester: 3900,
    Dorion: 5950,
    Dresden: 3750,
    Dryden: 5850,
    Dundalk: 4700,
    Dunnville: 3660,
    Durham: 4340,
    Dutton: 3700,
    Earlton: 5730,
    Edison: 5740,
    'Elliot Lake': 4950,
    Elmvale: 4200,
    Embro: 3950,
    Englehart: 5800,
    Espanola: 4920,
    Exeter: 3900,
    'Fenelon Falls': 4440,
    Fergus: 4300,
    Forest: 3740,
    'Fort Erie': 3650,
    'Fort Erie (Ridgeway)': 3600,
    'Fort Frances': 5440,
    Gananoque: 4010,
    Geraldton: 6450,
    Glencoe: 3680,
    Goderich: 4000,
    'Gore Bay': 4700,
    Graham: 5940,
    'Gravenhurst (Muskoka Airport)': 4760,
    Grimsby: 3520,
    Guelph: 4270,
    Guthrie: 4300,
    Haileybury: 5600,
    'Haldimand (Caledonia)': 3750,
    'Haldimand (Hagersville)': 3760,
    Haliburton: 4840,
    'Halton Hills (Georgetown)': 4200,
    Hamilton: 3460,
    Hanover: 4300,
    Hastings: 4280,
    Hawkesbury: 4610,
    Hearst: 6450,
    'Honey Harbour': 4300,
    Hornepayne: 6340,
    Huntsville: 4850,
    Ingersoll: 3920,
    'Iroquois Falls': 6100,
    Jellicoe: 6400,
    Kapuskasing: 6250,
    Kemptville: 4540,
    Kenora: 5630,
    Killaloe: 4960,
    Kincardine: 3890,
    Kingston: 4000,
    Kinmount: 4600,
    'Kirkland Lake': 6000,
    Kitchener: 4200,
    'Kitchenuhmaykoosib / Big Trout Lake': 7450,
    Lakefield: 4330,
    'Lansdowne House': 7150,
    Leamington: 3400,
    Lindsay: 4320,
    "Lion's Head": 4300,
    Listowel: 4300,
    London: 3900,
    Lucan: 3900,
    Maitland: 4080,
    Markdale: 4500,
    Markham: 4000,
    Martin: 5900,
    Matheson: 6080,
    Mattawa: 5050,
    Midland: 4200,
    Milton: 3920,
    Milverton: 4200,
    Minden: 4640,
    Mississauga: 3880,
    "Mississauga (Lester B. Pearson Int'l)": 3890,
    'Mississauga (Port Credit)': 3780,
    Mitchell: 4100,
    Moosonee: 6800,
    Morrisburg: 4370,
    'Mount Forest': 4700,
    Nakina: 6500,
    'Nanticoke (Jarvis)': 3700,
    'Nanticoke (Port Dover)': 3600,
    Napanee: 4140,
    Newcastle: 3990,
    'Newcastle (Bowmanville)': 4000,
    'New Liskeard': 5570,
    Newmarket: 4260,
    'Niagara Falls': 3600,
    'North Bay': 5150,
    Norwood: 4320,
    Oakville: 3760,
    Orangeville: 4450,
    Orillia: 4260,
    Oshawa: 3860,
    'Ottawa (Metropolitan)': 4500,
    'Ottawa (Barrhaven)': 4500,
    'Ottawa (City Hall)': 4440,
    'Ottawa (Kanata)': 4520,
    "Ottawa (M-C Int'l Airport)": 4500,
    'Ottawa (Orléans)': 4500,
    'Owen Sound': 4030,
    'Pagwa River': 6500,
    Paris: 4000,
    Parkhill: 3800,
    'Parry Sound': 4640,
    'Pelham (Fonthill)': 3690,
    Pembroke: 4980,
    Penetanguishene: 4200,
    Perth: 4340,
    Petawawa: 4980,
    Peterborough: 4400,
    Petrolia: 3640,
    'Pickering (Dunbarton)': 3800,
    Picton: 3980,
    Plattsville: 4150,
    'Point Alexander': 4960,
    'Port Burwell': 3800,
    'Port Colborne': 3600,
    'Port Elgin': 4100,
    'Port Hope': 3970,
    'Port Perry': 4260,
    'Port Stanley': 3850,
    Prescott: 4120,
    Princeton: 4000,
    Raith: 5900,
    'Rayside-Balfour (Chelmsford)': 5200,
    'Red Lake': 6220,
    Renfrew: 4900,
    'Richmond Hill': 4000,
    Rockland: 4600,
    Sarnia: 3750,
    'Sault Ste. Marie': 4960,
    Schreiber: 5960,
    Seaforth: 4100,
    Shelburne: 4700,
    Simcoe: 3700,
    'Sioux Lookout': 5950,
    'Smiths Falls': 4340,
    Smithville: 3650,
    'Smooth Rock Falls': 6250,
    Southampton: 4100,
    'South River': 5090,
    'St. Catharines': 3540,
    'St. Marys': 4000,
    'St. Thomas': 3780,
    Stirling: 4220,
    Stratford: 4050,
    Strathroy: 3780,
    'Sturgeon Falls': 5200,
    Sudbury: 5180,
    Sundridge: 5080,
    Tavistock: 4100,
    Temagami: 5420,
    Thamesford: 3950,
    Thedford: 3710,
    'Thunder Bay': 5650,
    Tillsonburg: 3040,
    Timmins: 5940,
    'Timmins (Porcupine)': 6000,
    Etobicoke: 3800,
    'North York': 3760,
    Scarborough: 3800,
    'Toronto (City Hall)': 3520,
    Trenton: 4110,
    'Trout Creek': 5100,
    Uxbridge: 4240,
    'Vaughan (Woodbridge)': 4100,
    Vittoria: 3680,
    Walkerton: 4300,
    Wallaceburg: 3600,
    Waterloo: 4200,
    Watford: 3740,
    Wawa: 5040,
    Welland: 3670,
    'West Lorne': 3700,
    Whitby: 3620,
    'Whitby (Brooklin)': 4010,
    'White River': 6150,
    Wiarton: 4300,
    Windsor: 3400,
    Wingham: 4220,
    Woodstock: 3910,
    Wyoming: 3700,
  },
  'Prince Edward Island': {
    Charlottetown: 4460,
    Souris: 4550,
    Summerside: 4600,
    Tignish: 4770,
  },
  Québec: {
    'Acton Vale': 4620,
    Alma: 5080,
    Amos: 6160,
    Aylmer: 4520,
    'Baie-Comeau': 6020,
    'Baie-Saint-Paul': 5280,
    Beauport: 5100,
    Bedford: 4420,
    Beloeil: 4500,
    Brome: 4730,
    Brossard: 4420,
    Buckingham: 4880,
    "Campbell's Bay": 4900,
    Chambly: 4450,
    Coaticook: 4750,
    Contrecoeur: 4500,
    Cowansville: 4540,
    'Deux-Montagnes': 4440,
    Dolbeau: 6250,
    Drummondville: 4700,
    Farnham: 4500,
    'Fort-Coulonge': 4950,
    Gagnon: 7600,
    Gaspé: 5300,
    Gatineau: 4600,
    Gracefield: 5080,
    Granby: 4500,
    'Harrington Harbour': 5150,
    'Havre-Saint-Pierre': 6100,
    Hemmingford: 4380,
    Hull: 4550,
    Iberville: 4450,
    Inukjuak: 9150,
    Joliette: 4720,
    Kuujjuaq: 8550,
    Kuujjuarapik: 7990,
    Lachute: 4640,
    'Lac-Mégantic': 5180,
    'La Malbaie': 5400,
    'La Pocatière': 5160,
    'La Tuque': 5050,
    Lennoxville: 4700,
    Léry: 4420,
    Loretteville: 5200,
    Louiseville: 4900,
    Magog: 4730,
    Malartic: 5240,
    Maniwaki: 5280,
    Masson: 4610,
    Matane: 5510,
    'Mont-Joli': 5370,
    'Mont-Laurier': 5320,
    Montmagny: 5090,
    Beaconsfield: 4440,
    Dorval: 4400,
    Laval: 4500,
    'Montréal (City Hall)': 4200,
    'Montréal-Est': 4870,
    'Montréal-Nord': 4870,
    Outremont: 4300,
    Pierrefonds: 4430,
    'Sainte-Anne-de-Bellevue': 4460,
    'Saint-Lambert': 4400,
    'Saint-Laurent': 4270,
    Verdun: 4200,
    'Nicolet (Gentilly)': 4900,
    Nitchequon: 8100,
    Noranda: 6050,
    Percé: 5400,
    Pincourt: 4480,
    Plessisville: 4180,
    'Port-Cartier': 5110,
    Puvirnituq: 9200,
    'Ancienne-Lorette': 5130,
    Lévis: 5050,
    Québec: 5080,
    'Sainte-Foy': 5160,
    Sillery: 5070,
    Richmond: 4700,
    Rimouski: 5300,
    'Rivière-du-Loup': 5380,
    Roberval: 5750,
    'Rock Island': 4860,
    Rosemère: 4550,
    Rouyn: 6050,
    Saguenay: 5700,
    'Saguenay (Bagotville)': 5700,
    'Saguenay (Jonquière)': 5650,
    'Saguenay (Kénogami)': 5650,
    'Sainte-Agathe-des-Monts': 5390,
    'Saint-Eustache': 4500,
    'Saint-Félicien': 5850,
    'Saint-Georges-de-Cacouna': 5400,
    'Saint-Hubert': 4490,
    'Saint-Hubert-de-Rivière-du-Loup': 5520,
    'Saint-Hyacinthe': 4500,
    'Saint-Jean-sur-Richelieu': 4450,
    'Saint-Jérôme': 4820,
    'Saint-Jovite': 5250,
    'Saint-Lazare / Hudson': 4520,
    'Saint-Nicolas': 4990,
    'Salaberry-de-Valleyfield': 4400,
    Schefferville: 8550,
    Senneterre: 6180,
    'Sept-Îles': 6200,
    Shawinigan: 5050,
    Shawville: 4880,
    Sherbrooke: 4700,
    Sorel: 4550,
    Sutton: 4600,
    Tadoussac: 5450,
    Témiscaming: 5020,
    Terrebonne: 4500,
    'Thetford Mines': 5120,
    Thurso: 4820,
    'Trois-Rivières': 4900,
    'Val-des-Sources': 4800,
    "Val-d'Or": 6180,
    Varennes: 4500,
    Verchères: 4450,
    Victoriaville: 4900,
    'Ville-Marie': 5550,
    Wakefield: 4820,
    Waterloo: 4650,
    Windsor: 4700,
  },
  Yukon: {
    Aishihik: 7500,
    Dawson: 8120,
    'Destruction Bay': 7800,
    Faro: 7300,
    'Haines Junction': 7100,
    Snag: 8300,
    Teslin: 6770,
    'Watson Lake': 7470,
    Whitehorse: 6580,
  },
};

const PROVINCE_TRANSLATION_KEYS = {
  'British Columbia': 'british_columbia',
  'New Brunswick': 'new_brunswick',
  'Newfoundland and Labrador': 'newfoundland_and_labrador',
  'Northwest Territories': 'northwest_territories',
  'Nova Scotia': 'nova_scotia',
  'Prince Edward Island': 'prince_edward_island',
  Québec: 'quebec',
};

/**
 * Returns HDD data with translated province names
 */
export const getTranslatedHDD = t => {
  const translated = {};
  Object.entries(HDD_DATA).forEach(([englishProvince, regions]) => {
    const translationKey = PROVINCE_TRANSLATION_KEYS[englishProvince];
    const translatedProvince = translationKey ? t(`thermal_calculator.provinces.${translationKey}`) : englishProvince;
    translated[translatedProvince] = regions;
  });
  return translated;
};

export default HDD_DATA;
